import { render, staticRenderFns } from "./reportItem.vue?vue&type=template&id=b5046828&scoped=true"
import script from "./reportItem.vue?vue&type=script&lang=js"
export * from "./reportItem.vue?vue&type=script&lang=js"
import style0 from "./reportItem.vue?vue&type=style&index=0&id=b5046828&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5046828",
  null
  
)

export default component.exports